import React, { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/swiper-bundle.min.css";
import image1 from "../../../assets/Images/1.png";
import image2 from "../../../assets/Images/2.png";
import image3 from "../../../assets/Images/3.png";

const FmgeCourse = () => {
  const [enquiryForm, setEnquiryForm] = useState(false);
  const [showDoubtForm, setShowDoubtForm] = useState(false);
  const [success, setSuccess] = useState(false);
  const [id, setId] = useState("");

  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    country: "",
  });

  const [doubtForm, setDoubtForm] = useState({
    date: "",
    topic: "",
  });

  const courses = [
    {
      _id: "1",
      courseName: "Doubt Resolution",
      courseDescription: "FMGE doubt resolution",
      thumbnail: image2,
    },
    {
      _id: "2",
      courseName: "Crash Course",
      courseDescription: "FMGE crash course",
      thumbnail: image1,
    },
    {
      _id: "3",
      courseName: "Regular Course",
      courseDescription: "FMGE regular course",
      thumbnail: image3,
    },
  ];

  const handleCardClick = (courseId) => {
    const details = localStorage.getItem("details");
    if (!details) {
      setId(courseId);
      setEnquiryForm(true);
    } else if (courseId === "1") {
      setShowDoubtForm(true);
    } else {
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prevForm) => ({
      ...prevForm,
      [name]: value,
    }));
  };

  const handleDoubtChange = (e) => {
    const { name, value } = e.target;
    setDoubtForm((prevForm) => ({
      ...prevForm,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const sendResponse = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_BASE_URL}/reach/form`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              ...form,
              ...doubtForm,
            }),
          }
        );

        if (response.ok) {
          setSuccess(true);
          setTimeout(() => {
            setShowDoubtForm(false);
            setSuccess(false); 
          }, 2000); 
        }
         else {
          alert("Something went wrong. Please try again.");
        }
      } catch (error) {
        console.error("Error submitting form:", error);
        alert("Failed to submit form.");
      }
    };

    sendResponse();
  };

  const handleEnquiry = (e) => {
    e.preventDefault();
    if (id === "1") {
      setEnquiryForm(false);
      setShowDoubtForm(true);
    } else {
      handleSubmit(e);
    }
  };
  return (
    <>
      {enquiryForm && (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center px-4">
          <div className="bg-white rounded-2xl p-8 w-full max-w-md shadow-2xl relative">
            <h2 className="text-3xl font-bold mb-6 text-center text-[#C81E1E]">
              Contact Us
            </h2>
            {success && (
              <p className="mt-4 text-green-600 font-medium">We'll contact you soon</p>
            )}
            <form className="space-y-5" onSubmit={handleEnquiry}>
              <div>
                <label className="block text-sm font-semibold text-richblack-600 mb-2">
                  Full Name
                </label>
                <input
                  type="text"
                  name="name"
                  value={form.name}
                  onChange={handleChange}
                  placeholder="Enter your full name"
                  className="w-full px-4 py-3 border border-richblack-900 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#C81E1E] focus:border-transparent transition duration-200"
                />
              </div>

              <div>
                <label className="block text-sm font-semibold text-richblack-600 mb-2">
                  Email Address
                </label>
                <input
                  type="email"
                  name="email"
                  value={form.email}
                  onChange={handleChange}
                  placeholder="Enter your email"
                  className="w-full px-4 py-3 border border-richblack-900 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#C81E1E] focus:border-transparent transition duration-200"
                />
              </div>

              <div>
                <label className="block text-sm font-semibold text-richblack-600 mb-2">
                  Phone Number
                </label>
                <input
                  type="tel"
                  name="phone"
                  value={form.phone}
                  onChange={handleChange}
                  placeholder="Enter your phone number"
                  className="w-full px-4 py-3 border border-richblack-900 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#C81E1E] focus:border-transparent transition duration-200"
                />
              </div>

              <div>
                <label className="block text-sm font-semibold text-richblack-600 mb-2">
                  MBBS Country
                </label>
                <input
                  type="text"
                  name="country"
                  value={form.country}
                  onChange={handleChange}
                  placeholder="Country where you completed MBBS"
                  className="w-full px-4 py-3 border border-richblack-900 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#C81E1E] focus:border-transparent transition duration-200"
                />
              </div>

              <button
                type="submit"
                className="w-full py-3 mt-4 bg-[#C81E1E] text-white rounded-lg hover:bg-red-700 transition duration-300 font-semibold text-lg"
              >
                Submit
              </button>
            </form>

            <button
              onClick={() => setEnquiryForm(false)}
              className="absolute top-4 right-4 text-richblack-600 hover:text-[#C81E1E] transition text-2xl font-bold"
            >
              ✕
            </button>
          </div>
        </div>
      )}

      {showDoubtForm && (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center px-4">
          <div className="bg-gradient-to-br from-white to-gray-100 rounded-2xl p-8 w-full max-w-md shadow-2xl relative">
            <h2 className="text-3xl font-bold mb-6 text-center text-[#C81E1E]">
              Please fill the form
            </h2>

            <form className="space-y-5" onSubmit={handleSubmit}>
              <div>
                <label className="block text-sm font-semibold text-richblack-600 mb-2">
                  Date and time
                </label>
                <input
                  type="datetime-local"
                  name="date"
                  value={doubtForm.date}
                  onChange={handleDoubtChange}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#C81E1E] transition"
                  style={{ color: "black", backgroundColor: "white" }}
                />
              </div>

              <div>
                <label className="block text-sm font-semibold text-richblack-600 mb-2">
                  Topic which you want to discuss
                </label>
                <input
                  type="text"
                  name="topic"
                  value={doubtForm.topic}
                  onChange={handleDoubtChange}
                  placeholder="Topic"
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#C81E1E] transition"
                />
              </div>

              <button
                type="submit"
                className="w-full py-3 mt-4 bg-[#C81E1E] text-white rounded-lg hover:bg-red-700 transition duration-300 font-semibold text-lg"
              >
                Submit Details
              </button>
            </form>

            <button
              onClick={() => setShowDoubtForm(false)}
              className="absolute top-4 right-4 text-gray-600 hover:text-[#C81E1E] transition text-2xl font-bold"
            >
              ✕
            </button>
          </div>
        </div>
      )}

      <div className="course-swiper mx-4 my-8">
        <Swiper
          spaceBetween={30}
          // slidesPerView={2}
          // autoplay={{ delay: 2500 }}
          // loop={true}
          className="swiper-container"
          pagination={{
            clickable: true,
            el: ".course-pagination",
          }}
          breakpoints={{
            320: {
              slidesPerView: 1,
              spaceBetween: 10,
            },
            640: {
              slidesPerView: 2,
              spaceBetween: 20,
            },
            1024: {
              slidesPerView: 3,
              spaceBetween: 30,
            },
          }}
        >
          {courses.map((course) => {
            return (
              <SwiperSlide
                key={course._id}
                onClick={() => handleCardClick(course._id)}
              >
                <div className="course-card p-4 bg-richblack-400 hover:bg-richblack-800 rounded-lg shadow-lg cursor-pointer transform transition-transform duration-300 hover:scale-105 dark:bg-richblack-100 dark:text-richblack-800 dark:hover:bg-richblack-300">
                  <img
                    src={course.thumbnail}
                    alt={course.courseName}
                    className="h-[250px] w-full object-cover rounded-t-lg"
                  />
                  <div className="course-info p-4">
                    <h3 className="text-xl font-bold mb-2 text-white dark:text-richblack-700">
                      {course.courseName}
                    </h3>
                    <p className="text-gray-700 mb-2 line-clamp-3 text-white dark:text-richblack-700">
                      {course.courseDescription}
                    </p>
                    {/* <p className="text-gray-900 font-semibold text-white dark:text-richblack-700">
                      Price: ₹{course.price}
                    </p> */}
                  </div>
                </div>
              </SwiperSlide>
            );
          })}
        </Swiper>
        <div className="mt-20 flex justify-center gap-3">
          <div className="course-pagination flex justify-center gap-3"></div>
        </div>
      </div>
    </>
  );
};

export default FmgeCourse;
